module.exports = __webpack_public_path__ + "img/honer19.514bc74b.jpg";